import React from 'react';
import BaseComponent from './BaseComponent';
import Venues from './Venues';
import FacebookLogin from './FacebookLogin';
import {connect} from 'react-redux';

export class PureApp extends BaseComponent {
    render() {
        const {children, loading} = this.props;

        if (loading) {
            return <div className="app">Loading ...</div>;
        }

        return <div className="app">
            <div className="app-header">
                Live Results
                <FacebookLogin />
            </div>
            <div className="app-body">
                {children}
            </div>
        </div>;
    }
}

function mapStateToProps({app}) {
    return {loading: app.get('loading')};
}

export default connect(mapStateToProps)(PureApp);



/** WEBPACK FOOTER **
 ** ./src/components/App.jsx
 **/